<template>
    <div class="admin-attendance-filter">
        <Card dis-hover>
            <Row type="flex">
                <Col :xs="2" :sm="6" :md="6" :lg="6" class="d-flex-center user-col">
                    <Select
                        v-model="selectedEmployee"
                        :value="employeeList"
                        filterable
                        clearable
                        placeholder="All Employees"
                        @on-change="handleUserChanged"
                    >
                        <Option v-for="item in employeeList" :key="item.key" :value="item.value">
                            {{ item.name }}
                        </Option>
                    </Select>
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import Bugsnag from '@bugsnag/js';
import { getUsers } from '@/services/users.services';
export default {
    props: {
        filterEmployees: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            selectedStatus: this.$route.query.status,
            selectedEmployee: this.$route.query.user,
            employeeList: [],
            filterEmployeeList: [],
        };
    },
    watch: {
        filterEmployees(data) {
            this.filterEmployeeList = data;
        },
    },

    created() {
        if (this.$route.query.status) {
            this.$emit('status-changed', this.selectedStatus);
        }
        if (this.$route.query.user) {
            this.$emit('user-changed', this.selectedEmployee);
        }
    },
    mounted() {
        this.handleGetAllEmployees();
    },

    methods: {
        handleUserChanged(user) {
            this.$emit('user-changed', user);
            try {
                this.$router.replace({ query: null }).catch(() => {});
            } catch (e) {
                Bugsnag.notify(e);
            }
        },
        handleGetAllEmployees() {
            this.isLoading = true;
            this.employeeList = [];
            getUsers()
                .then((res) => {
                    if (res.data.length) {
                        this.employeeList = res.data
                            .filter((x) => x.mainRole != 'client' && x.mainRole != 'admin' && x.isArchived == false)
                            .map((i) => {
                                return {
                                    value: i._id,
                                    label: i.name,
                                    name: i.name,
                                    key: i._id,
                                    _id: i._id,
                                };
                            });
                    }
                    this.isLoading = false;
                })
                .catch(() => {
                    this.$Message.error('Failed to get users');
                    this.isLoading = false;
                });
        },
    },
};
</script>
<style lang="scss">
.admin-attendance-filter {
    .ivu-row {
        .export-btn {
            justify-content: end;
            button {
                border-radius: 15px;
            }
        }
    }
    .user-col {
        margin-right: 10px;
    }
}
@media screen and (max-width: 767px) {
    .admin-attendance-filter {
        .ivu-row {
            display: block;

            .ivu-col {
                max-width: 100%;
            }
            .ivu-col-span-xs-2 {
                margin: 5px 0;
            }
            .filter-btn button {
                width: 100%;
            }
        }
    }
}
</style>
